export default "__VITE_ASSET__1kfeDXOz__"